export default __webpack_public_path__ + "static/media/profile-icon.69674b19.svg";